import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { useAuth } from '../auth/AuthContext';
import { useAppContext } from '../context/AppContext';
import { SectionCard } from '../components/energy/EnergyUi';
import CostProfileManager from '../components/energy/CostProfileManager';

export default function SettingsView() {
  const auth = useAuth();
  const { customerContext } = useAppContext();
  const canManage = auth.isOwner || auth.isSuperuser;
  return <Box>
    <Typography variant="h4" sx={{ mb: 2 }}>Settings</Typography>
    <SectionCard title="Account costing" subtitle="Lease payments, operating charges and utility rates">
      {!canManage ? <Alert severity="info">Your demo account has read-only access. View its proposed lease costs in Economics.</Alert>
        : !customerContext ? <Alert severity="info">Select an account to manage its costing.</Alert>
          : <CostProfileManager key={customerContext.customerId} />}
    </SectionCard>
  </Box>;
}
